
export default function AppObjectFieldStaticText({ field, action, value }) {
  console.log(`AppObjectFieldStaticText rendered: ${field.name}`)

  return (
    <div>{value}</div>
  )
}
